export default {
	BUTTON: 'button',
	SEPARATOR: 'separator',
}
